import { addExternalLink } from './add-external-link';
import { deleteExternalLink } from './delete-external-link';
import { fetchExternalLinkIcon } from './fetch-external-link-icon';
import { fetchExternalLinks } from './fetch-external-links';
import { reorderExternalLink } from './reorder-external-link';
import { updateExternalLink } from './update-external-link';

export const actions = {
	addExternalLink,
	fetchExternalLinks,
	deleteExternalLink,
	updateExternalLink,
	reorderExternalLink,
	fetchExternalLinkIcon,
} as const;

export type Actions = typeof actions;
